import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Documentos from '../../Documentos/Documentos';
import Timestamp from '../../Timestamp/Timestamp';
import { mergeQuery } from '../../../helpers/querystring';

const DocumentosTemplate = (data) => {
  const { items, query } = data;
  const location = useLocation();
  const pathname = location.pathname;
  const newQuery = mergeQuery(location, query);
  return (
    <>
      <div className="items documentos-template">
        <Timestamp />
        <Documentos
          documentos={items}
          params={newQuery}
          url={pathname}
          allowExport={true}
        />
      </div>
    </>
  );
};

DocumentosTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default DocumentosTemplate;
